import { Paywall } from "../../../schema/models";
import { HttpApiEndpoint, HttpApiGroup, HttpApiSchema, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { Predicate, Schema } from "effect";
import { ConflictError, InternalServerError, NotFound, BadRequest, ErrorBaseSchema, Unauthorized } from "@superwall/api-schema-utils";
import { ApplicationId, PaywallIdFromString } from "@superwall/drizzle/branded";
export class InvalidPaywall extends Schema.TaggedError()("@superwall/schema/models/errors/InvalidPaywall", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/invalid-paywall")
    })
}, HttpApiSchema.annotations({
    status: 400,
    title: "Invalid Paywall",
    description: "The paywall has invalid config data"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/InvalidPaywall");
    }
}
export default HttpApiGroup.make("paywallsv1").annotate(OpenApi.Title, "Paywalls V1").add(HttpApiEndpoint.get("listPaywalls")`/:applicationId`.setPath(Schema.Struct({
    applicationId: Schema.NumberFromString
})).addSuccess(Paywall.List).setUrlParams(Paywall.UrlParams).addError(NotFound).addError(InternalServerError).addError(Unauthorized).annotate(OpenApi.Summary, "List Paywalls")).add(HttpApiEndpoint.post("prepareSnapshotForPromotion")`/:id/prepare-snapshot`.setPath(Schema.Struct({
    id: PaywallIdFromString
})).setPayload(Schema.Struct({
    applicationId: ApplicationId,
    snapshot: Schema.Struct({
        store: Schema.Any,
        schema: Schema.Any
    }),
    bypassProductsMissingValues: Schema.optional(Schema.Boolean)
})).addError(NotFound).addError(BadRequest).addError(InternalServerError).addError(InvalidPaywall).addError(Unauthorized).addError(ConflictError).addSuccess(Schema.Struct({
    success: Schema.Boolean,
    data: Schema.Struct({
        snapshotIdentifier: Schema.String
    })
})).annotate(OpenApi.Summary, "Prepare Paywall Snapshot for Promotion")).add(HttpApiEndpoint.post("promoteFromSnapshot")`/:id/promote-from-snapshot`.setPath(Schema.Struct({
    id: PaywallIdFromString
})).setPayload(Schema.Struct({
    snapshotIdentifier: Schema.String,
    applicationId: ApplicationId
})).addError(NotFound).addError(InternalServerError).addError(ConflictError).addError(Unauthorized).addError(BadRequest).addSuccess(Schema.Struct({
    version: Schema.Number
}))).prefix("/v1/paywalls").middleware(Authn) // TODO: HighPrio
 // promoteFromSnapshot
 // getLatestSnapshotByVersion
 // TODO: LowPrio
 // getSnippetResource
 // getPaywallExperimentVariants
 // getLatestResourceByType
 // createOrUpdateResource
 // captureCrash
;
